import { useMemo } from "react";
import _ from "lodash";

import { colors } from "theme/palette";

import Stack from "components/Stack";
import Tag from "components/Tag";
import Text from "components/Text";

import PrintableFieldTitle from "pages/PrintableChecklist/components/PrintableFieldTitle";

import { EFieldStatus } from "entities/Field/constants";
import { IField } from "entities/Field/sdk";
import { formatFieldValue } from "entities/Field/utils";

export interface IPrintableField {
  field: IField;
}

const PrintableField = ({ field }: IPrintableField) => {
  const value = useMemo(() => {
    return _.get(field.custom_values, "[0].default_value");
  }, [field.custom_values]);

  return (
    <Stack
      id={field.field_id.toString()}
      direction="row"
      justifyContent="space-between"
      alignItems="flex-start"
      spacing={2}
      sx={{
        padding: 0.5,
        borderBottom: `1px solid ${colors.blue20}`,
      }}
    >
      <PrintableFieldTitle field={field} />
      <Stack
        direction="row"
        spacing={1}
        paddingTop={0.5}
        alignItems="center"
        sx={{ maxWidth: "50%", minWidth: "none", alignSelf: "center" }}
      >
        {field.status !== EFieldStatus.NA && !value && (
          <Tag label="missing" variant="red" />
        )}
        {field.status !== EFieldStatus.NA && value && (
          <Text
            variant="text2"
            sx={{
              wordBreak: "break-word",
            }}
          >
            {formatFieldValue({
              fieldValue: value,
              fieldFormatType: field.field_format_type,
            })}
          </Text>
        )}
        {field.status === EFieldStatus.NA && (
          <Text sx={{ color: colors.gray60 }}>N/A</Text>
        )}
      </Stack>
    </Stack>
  );
};

export default PrintableField;
